import { createFileRoute } from "@tanstack/react-router";
import { LiveHome } from "@/pages/3d/live/LiveHome";

export const Route = createFileRoute("/demo/3d/live/")({
  component: LiveHome,
});
